// Accounting Promotions Vuex

import state from './promotionStates.js'
import * as getters from './promotionGetters.js'
import * as mutations from './promotionMutations.js'
import * as actions from './promotionActions.js'

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
